<template>
  <div class="amp_main">
    <div class="com_con" v-loading="loading">
      <div class="flex_bet_h tools_titmod">
        <span class="tools_tit">音频修改 </span>
        <img src="../../assets/images/img2/offlogin.png" class="tools_off" @click="hide" />
      </div>
      <div class="tools_upfile" @click="show_list = true" style="height:72px">
        <div v-if="wodk_url == ''">
          <img src="../../assets/images/img2/addfile.png" class="tools_addfile" />
          <p>添加音频</p>
        </div>
        <div v-else>
          <p class="amp_url overflow_hide">{{ wodk_url }}</p>
          <p>已选择</p>
        </div>
      </div>
      <p>修改属性</p>
      <div class="tools_ampcon">
        <p class="flex_bet_h">
          <span class="tools_amptext1">采样率</span>
          <span class="tools_amptext2">{{ sampling }}</span>
        </p>
        <el-slider v-model="sampling" :min="8000" :max="48000" @change="setSampling"></el-slider>
        <p class="flex_bet_h">
          <span>8000</span>
          <span>48000</span>
        </p>
      </div>
      <div class="tools_ampcon">
        <p class="flex_bet_h">
          <span class="tools_amptext1">比特率</span>
          <span class="tools_amptext2">{{ bit_rate }}k</span>
        </p>
        <el-slider v-model="bit_rate" :min="32" :max="320" @change="setBitRate"></el-slider>
        <p class="flex_bet_h">
          <span>8000k</span>
          <span>48000k</span>
        </p>
      </div>
      <div class="track_mod">
        <p>声道</p>
        <div class="flex_ali track_btn_mod">
          <div class="track_btn flex_cen" :class="track==1?'track_btn_act':''" @click="track=1">单声道</div>
          <div class="track_btn flex_cen" :class="track==2?'track_btn_act':''" @click="track=2">双声道</div>
        </div>
      </div>
      <div class="flex_bet_h">
        <div class="tools_btn" v-if="!play_state" @click="startAmendAudio(false)">
          <img src="../../assets/images/play.png" class="tools_btn_icon" />
          <span>试听效果</span>
        </div>
        <div class="tools_btn" @click="stopPlay" v-else>
          <img src="../../assets/images/pause.png" class="tools_btn_icon" />
          <span>暂停播放</span>
        </div>
        <div class="tools_btn tools_btn2" @click="startAmendAudio(true)">
          <img src="../../assets/images/img2/exfile.png" class="tools_btn_icon" />
          <span>导出音频</span>
        </div>
      </div>
    </div>
    <audioLiist v-if="show_list" @hide="show_list = false" @setWork="setWork" />
  </div>
</template>
<script>
// 作品选择组件
import audioLiist from "./audio_list.vue";
export default ({
  components: {
    audioLiist,
  },
  data() {
    return {
      audio: new Audio(), //播放器
      loading: false, //加载动画状态
      show_list: false,//作品选择组件显示状态
      wodk_url: '',// 选择的音频地址
      sampling: 8000,//采样率
      bit_rate: 32,//比特率
      track: 1,//声道(1-单声道；2-双声道)
      play_state: false,//播放状态
      sampling_list: [8000, 11025, 16000, 22050, 24000, 32000, 44100, 48000], //采样率列表
      bit_list: [32, 64, 96, 128, 160, 192, 320], //比特率列表
    }
  },
  methods: {
    // 停止播放
    stopPlay() {
      this.audio.pause();
      this.play_state = false;
    },
    // 修改音频
    startAmendAudio(isextend) {
      // isextend？true=导出音频：false=试听效果
      let self = this;
      if (this.wodk_url == "") {
        this.$message({
          message: "请选择需要修改的音频",
          type: "warning",
        });
        return;
      }
      this.loading = true;
      let url = self.$store.state.app_api + self.$store.state.app_url.modifyMp3;
      let json = {
        url: this.wodk_url,
        sampleRate: this.sampling,
        bitRate: this.bit_rate,
        channels: this.track
      };
      this.$request.postHttp(json, url, (response) => {
        console.log(2, response)
        self.loading = false;
        let mp3url = response.model.mp3url;

        if (!mp3url) {
          self.$message.error("操作失败！");
        }
        if (!isextend) {
          self.audio.src = mp3url;
          self.audio.play();
          self.play_state = true;
          self.monitorPlay()
        } else {
          this.$globalFun.downloadDub(mp3url);
        }
      })
    },
    // 修改比特率
    setBitRate(val) {
      let bit_list = this.bit_list
      let final = this.getListNear(bit_list, val)
      this.bit_rate = final
    },
    // 修改采样率
    setSampling(val) {
      let sampling_list = this.sampling_list
      let final = this.getListNear(sampling_list, val)
      this.sampling = final
    },
    // 取数值最接近数组的中值
    getListNear(list, val) {
      /*
      list:取值数组；
      val:接近对比值；
      */
      for (let i = 0; i < list.length; i++) {
        if (parseInt(list[i]) >= parseInt(val)) {
          if (i == 0) return list[0]
          let before = Math.abs(parseInt(list[i - 1]) - parseInt(val))
          let after = Math.abs(parseInt(list[i]) - parseInt(val))
          let final = (before > after) ? parseInt(list[i]) : parseInt(list[i - 1])
          return final
        }
      }
    },
    // 关闭点击
    hide() {
      this.$emit("hide");
    },
    // 选择作品
    setWork(e) {
      this.show_list = false
      this.wodk_url = e.musicpath
    }
  }
})
</script>
<style>
@import url("../../assets/css/tools.css");
</style>



// WEBPACK FOOTER //
// src/components/tools/audio_amend.vue